const logytechTranslate = {
  "transactions": "Errores de llamado a servicio"
}

export default logytechTranslate
